/**
 * @generated SignedSource<<a9763829497612ea78f81240b9e904ab>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type postContentPreviewFragment$data = {
  readonly content: any | null | undefined;
  readonly " $fragmentType": "postContentPreviewFragment";
};
export type postContentPreviewFragment$key = {
  readonly " $data"?: postContentPreviewFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"postContentPreviewFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "postContentPreviewFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "content",
      "storageKey": null
    }
  ],
  "type": "Post",
  "abstractKey": null
};

(node as any).hash = "8128a1744e123ce2f1ff21428febb282";

export default node;
